export default __webpack_public_path__ + "static/media/chat_error.0fd6dff2.svg";